export type Salutation = (typeof Salutation)[keyof typeof Salutation];

export const Salutation = {
    Undefined: 'Undefined',
    Mr: 'Mr',
    Mrs: 'Mrs',
} as const;
